/**
 * [polecenie właściciela 2026-09-29] PARA DAT OD – DO: „wszędzie gdzie dane są powiązane — jeżeli data OD jest późniejsza niż DO,
 * to automatycznie DO zmieniaj na datę OD” (zrzut: wniosek z „Od dnia 30 września” i „Do dnia 15 września”).
 *
 * JEDNA reguła dla całej aplikacji (zapadka: utils/__tests__/paraDat.0929.test.js skanuje formularze z parą dat):
 *   • po zmianie OD: DO, które jest WCZEŚNIEJSZE niż nowe OD, przyjmuje wartość OD (`wyrownajDo`);
 *   • pole DO dostaje `min = OD` (kalendarz nie podsuwa dnia sprzed OD — `minDlaDo`);
 *   • puste DO zostaje puste — reguła naprawia sprzeczność, nie wymyśla daty, której nikt nie podał.
 *
 * Wartości to napisy z DatePicker (`rrrr-mm-dd`) albo DateTimePicker (`rrrr-mm-ddTgg:mm`) — porównanie po chwili w czasie, więc para
 * „data” × „data z godziną” też działa (DO bez godziny = początek dnia).
 */

const chwila = (v) => {
    if (!v) return NaN;
    const s = String(v);
    const d = new Date(s.length === 10 ? `${s}T00:00:00` : s);
    return d.getTime();
};

/** Czy DO jest wcześniejsze niż OD (obie wartości podane i poprawne). */
export const doPrzedOd = (od, doW) => {
    const a = chwila(od);
    const b = chwila(doW);
    return !Number.isNaN(a) && !Number.isNaN(b) && b < a;
};

/** DO po zmianie OD: wcześniejsze niż OD → OD; inaczej bez zmian (także puste). */
export const wyrownajDo = (od, doW) => (doPrzedOd(od, doW) ? od : doW);

/** `min` dla pola DO — sama data (rrrr-mm-dd) z OD; puste OD = bez ograniczenia. */
export const minDlaDo = (od) => (od ? String(od).slice(0, 10) : undefined);

/**
 * Nazwa pola DO dla pola OD w formularzach dynamicznych (wnioski HR z konfiguratora): dateFrom→dateTo, startDate→endDate,
 * cokolwiekFrom→cokolwiekTo, cokolwiekOd→cokolwiekDo. `null` = to nie jest pole OD.
 */
export const nazwaPolaDo = (nazwa) => {
    if (!nazwa) return null;
    if (nazwa === "startDate") return "endDate";
    if (/From$/.test(nazwa)) return nazwa.replace(/From$/, "To");
    if (/Od$/.test(nazwa)) return nazwa.replace(/Od$/, "Do");
    if (nazwa === "od") return "do";
    return null;
};

/** Odwrotność `nazwaPolaDo` — nazwa pola OD dla pola DO; `null` = to nie jest pole DO. */
export const nazwaPolaOd = (nazwa) => {
    if (!nazwa) return null;
    if (nazwa === "endDate") return "startDate";
    if (/To$/.test(nazwa)) return nazwa.replace(/To$/, "From");
    if (/Do$/.test(nazwa)) return nazwa.replace(/Do$/, "Od");
    if (nazwa === "do") return "od";
    return null;
};

/**
 * Formularz dynamiczny: nowy stan po zmianie pola `nazwa` na `wartosc` — gdy to pole OD, a jego DO jest wcześniejsze, DO := OD.
 * `pola` (opcjonalnie) — lista pól formularza; pole DO musi w niej istnieć jako data, inaczej nic nie wyrównujemy.
 */
export const poZmianiePola = (stan, nazwa, wartosc, pola = null) => {
    const nowy = { ...stan, [nazwa]: wartosc };
    const polaDo = nazwaPolaDo(nazwa);
    if (!polaDo) return nowy;
    if (Array.isArray(pola) && !pola.some((f) => f.name === polaDo && (f.type === "date" || f.type === "datetime"))) return nowy;
    if (doPrzedOd(wartosc, nowy[polaDo])) nowy[polaDo] = wartosc;
    return nowy;
};
